import { dedupedPost } from 'src/app/core/utils/api-dedupe.util';
import { withReadableThemeText } from '../utils/theme-text-contrast.util';
import { agentThemeVars } from '../utils/agent-theme.util';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject, filter, from } from 'rxjs';
import * as $ from 'jquery';
import { AppService } from './app.service';
import { CONST_AWS_API, API, CONST_ONE_API, COUNTRIES_LIST, DEFAULT_IMAGE } from '../constants';
import { environment } from 'src/environments/environment';
import { AppPaymentTVService } from './app-payment-tv.service';
import { StorageService } from './storage.service';
import * as moment from "moment";
import { FormGroup } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { API as AWS_API, toast } from 'aws-amplify';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CurrencyPipe } from '@angular/common';
import { Client } from "@adzerk/decision-sdk";
import { Web3Service } from './web3.service';

declare let document: any;
declare let google: any;
declare var fbq: any;
declare let gtag: any;

// Second URL segments that are network-level routes, not a group slug (mirrors ChannelWebpageGuard).
const BASE_PATH_RESERVED_SEGMENTS = new Set([
  'signin', 'channelSearch', 'preview', 'sign-up', '404',
  'my-library', 'playlist', 'contactus', 'privacypolicy',
  'cookiepolicy', 'termsandconditions', 'subscription-list',
  'event', 'community', 'merchandise', 'album', 'album-video', 'channel', 'fastChannel',
  'user-dashboard', 'video', 'audio', 'recorded-video', 'stream', 'watch'
]);

@Injectable({
  providedIn: 'root'
})
export class CommanSubscribeService {
  // setLeftTabActiveBasedOnRouterURL(arg0: string) {
  //   throw new Error("Method not implemented.");
  // }

  userInfo: any = {};
  featureInfo: any = {};
  searchInfo: any = {};
  paymentInfo: any = {};
  locationInfo: any = {};
  orgId: any;
  streamInfo: any;
  expoInfo: any;
  slugInfo: any;
  ticketInfo: any;
  contactInfo: any;
  deviceInfo: string = '';
  currencyInfo: any;
  guestInfo: any;
  subEventsInfo: any;
  upcomingEventInfo: any;
  myListInfo: any;
  streamStatusInfo: any;
  ip: any = null;
  icWebpageSettingsData: any = {};
  mediaPlayerData: any = {};
  perfomerInfoData: any = {};
  activeGroupSlug: string = '';
  activeGroupId: number = 0;
  activeGroup: any = null;
  subscribePayInfoData: any;
  subscribePayedInfoData: any;
  albumBackHistory: any = "";
  deviceType = "browser";
  musicPlayerData: any;
  trackingCodeInfo: any;
  searchVal: any;
  transactionInfo: any;
  availBal: any;
  walletByOrg: { [organizationId: string]: any } = {};
  // userStatus:boolean = false;
  private userInfoSubject = new Subject<any>();
  private orgIdSubject = new Subject<any>();
  private featureInfoSubject = new Subject<any>();
  private subjectChangeMenuItem = new Subject<any>();
  private searchInfoSubject = new Subject<any>();
  private expoInfoSubject = new Subject<any>();
  private slugInfoSubject = new Subject<any>();
  private paymentInfoSubject = new Subject<any>();
  private streamInfoSubject = new Subject<any>();
  private subEventInfoSubject = new Subject<any>();
  private ticketInfoSubject = new Subject<any>();
  private HLSPlayVideoSubject = new Subject<any>();
  private deviceInfoSubject = new Subject<any>();
  private deviceAppSubject = new Subject<any>();
  private contactInfoSubject = new Subject<any>();
  private currencyInfoSubject = new Subject<any>();
  private screenStatusSubject = new Subject<any>();
  private upcomingEventInfoSubject = new Subject<any>();
  private myListInfoSubject = new Subject<any>();
  private streamStatusInfoSubject = new Subject<any>();
  private paymentStatusSubject = new Subject<any>();
  private icWebpageSettingsSubject = new Subject<any>();
  private perfomerInfoDataSubject = new Subject<any>();
  private subscribePayDataSubject = new Subject<any>();
  private subscribePayedDataSubject = new Subject<any>();
  private musicPlayerDataSubject = new Subject<any>();

  private mediaPlayerDataSubject = new Subject<any>();
  private trackingCodeInfoSubject = new Subject<any>();
  private searchValSubject = new Subject<any>();
  private albumStatusSUbject = new Subject<any>();
  private triggerAiAgentSubject = new Subject<boolean>();


  signUpInfo: any = {};
  signUpInfoSubject = new Subject<any>();
  eventSlugDataSubject = new Subject<any>();
  eventSlugData: any = {};
  returnUrl: any = "";
  // userStatusSubject = new Subject<any>();
  ContactDataSubject = new Subject<any>();
  contactsData: any;
  loginStatusInfo: any
  loginStatusInfoSubject = new Subject<any>();
  cartProductsSubject = new Subject<any>();
  showActiveProducts = new Subject<any>();
  currencyRatesSubject = new Subject<any>();
  checkoutTimer = new Subject<any>();
  selectedCardSubject = new Subject<any>();
  addressListSubject = new Subject<any>();
  savedCardsSubject = new Subject<any>();
  performerStatusSubject = new Subject<any>();
  albumStatusOpened = "";
  transactionInfoSubject = new Subject<any>();
  billingInfoSubject = new Subject<any>();
  totalAmountSubject = new Subject<any>();
  formsValidationSubject = new Subject<any>();
  userDetailSubject = new Subject<any>();
  formStatusSubject = new Subject<any>();
  tipsDonationsPaymentSuccessful = new Subject<any>();
  walletInfoSubject = new Subject<any>();
  updateAvailBalSubject = new Subject<any>();
  updatePaymentBtnSubject = new Subject<any>();
  lastAudioEndedSubject = new Subject<any>();
  scrollStatusSubject = new Subject<any>();
  cartRefreshSubject = new Subject<any>();
  getCartProdCountApiCallSubject = new Subject<any>();
  cryptoBalanceSubject = new Subject<any>();
  guestInfoSubject = new BehaviorSubject<any>(null);
  triggeredEventInfoSubject = new BehaviorSubject<any>(null);
  triggeredInfo: any;
  getCartProductListSubject = new BehaviorSubject<any>(null);
  streamWebpageSettings = new BehaviorSubject<any>(null);
  userCommunityStatus: any;
  userCommunityStatusSubject = new Subject<any>();
  private pubnubKeysetSubject = new BehaviorSubject<any>(null); // Change here
  pubnubKeyset = this.pubnubKeysetSubject;
  currentNetworkDataSubject = new BehaviorSubject<any>(null);
  currentNetworkData: any;
  spaceDetailsSubject = new BehaviorSubject<any>(null);
  spaceDetails: any;
  athletsDataSubject = new BehaviorSubject<any>(null);
  athletsData: any;
  // private userInfoSubject = new BehaviorSubject<any>({});
  videoStreamInfoSubject = new BehaviorSubject<any>(this.getSavedVideoStreamInfo());

  languages = [
    { code: 'en', name: "English", lang: "English" },
    { code: 'zh-CN', name: 'Chinese (Simplified)', lang: "简体中文" },
    { code: 'zh-TW', name: 'Chinese (Traditional)', lang: "中國傳統的" },
    { code: 'hi', name: "Hindi", lang: "हिंदी" },
    { code: 'id', name: "Indonesian", lang: "bahasa Indonesia" },
    { code: 'ur', name: "Urdu", lang: "اردو" },
    { code: 'pt', name: "Portuguese (Portugal, Brazil)", lang: "Português (Portugal, Brasil)" },
    { code: 'bn', name: "Bengali", lang: "বাংলা" },
    { code: 'ru', name: "Russian", lang: "русский" },
    { code: 'es', name: "Spanish", lang: "español" },
    { code: 'ja', name: "Japanese", lang: "日本" },
    { code: 'tl', name: "Tagalog (Filipino)", lang: "Tagalog (Filipino)" },
    { code: 'am', name: "Amharic", lang: "አማርኛ" },
    { code: 'ar', name: "Arabic", lang: "عربى" },
    { code: 'fr', name: "French", lang: "français" },
    { code: 'vi', name: "Vietnamese", lang: "Tiếng Việt" },
    { code: 'fa', name: "Persian", lang: "فارسی" },
    { code: 'tr', name: "Turkish", lang: "Türk" },
    { code: 'de', name: "German", lang: "Deutsche" },
    { code: 'th', name: "Thai", lang: "ไทย" },


    // { code: 'af', name: "Afrikaans" }, 
    // { code: 'sq', name: "Albanian" }, 
    // { code: 'am', name: "Amharic" }, 
    // { code: 'ar', name: "Arabic" }, 
    // { code: 'hy', name: "Armenian" }, 
    // { code: 'az', name: "Azerbaijani" }, 
    // { code: 'eu', name: "Basque" }, 
    // { code: 'be', name: "Belarusian" }, 
    // { code: 'bn', name: "Bengali" }, 
    // { code: 'bs', name: "Bosnian" }, 
    // { code: 'bg', name: "Bulgarian" }, 
    // { code: 'ca', name: "Catalan" }, 
    // { code: 'ceb ', name: "Cebuano" }, 
    // { code: 'zh-CN', name: 'Chinese (Simplified)' }, 
    // { code: 'zh-TW', name: 'Chinese (Traditional)' },
    // { code: 'co', name: "Corsican" }, 
    // { code: 'hr', name: "Croatian" }, 
    // { code: 'cs', name: "Czech" }, 
    // { code: 'da', name: "Danish" }, 
    // { code: 'nl', name: "Dutch" }, 
    // { code: 'en', name: "English" }, 
    // { code: 'eo', name: "Esperanto" }, 
    // { code: 'et', name: "Estonian" }, 
    // { code: 'fi', name: "Finnish" }, 
    // { code: 'fr', name: "French" }, 
    // { code: 'fy', name: "Frisian" }, 
    // { code: 'gl', name: "Galician" }, 
    // { code: 'ka', name: "Georgian" }, 
    // { code: 'de', name: "German" }, 
    // { code: 'el', name: "Greek" }, 
    // { code: 'gu', name: "Gujarati" }, 
    // { code: 'ht', name: "Haitian Creole	" }, 
    // { code: 'ha', name: "Hausa" }, 
    // { code: 'haw', name: "Hawaiian" }, 
    // { code: 'he', name: "Hebrew" }, 
    // { code: 'hi', name: "Hindi" },
    // { code: 'hmn', name: "Hmong" }, 
    // { code: 'hu', name: "Hungarian" }, 
    // { code: 'is', name: "Icelandic" }, 
    // { code: 'ig', name: "Igbo" }, 
    // { code: 'id', name: "Indonesian" }, 
    // { code: 'ga', name: "Irish" }, 
    // { code: 'it', name: "Italian" }, 
    // { code: 'ja', name: "Japanese" }, 
    // { code: 'jv', name: "Javanese" }, 
    // { code: 'kn', name: "Kannada" }, 
    // { code: 'kk', name: "Kazakh" }, 
    // { code: 'km', name: "Khmer" }, 
    // { code: 'rw', name: "Kinyarwanda" }, 
    // { code: 'ko', name: "Korean" }, 
    // { code: 'ku', name: "Kurdish" }, 
    // { code: 'ky', name: "Kyrgyz" }, 
    // { code: 'lo', name: "Lao" }, 
    // { code: 'lv', name: "Latvian" }, 
    // { code: 'lt', name: "Lithuanian" }, 
    // { code: 'lb', name: "Luxembourgish" }, 
    // { code: 'mk', name: "Macedonian" }, 
    // { code: 'mg', name: "Malagasy" }, 
    // { code: 'ms', name: "Malay" }, 
    // { code: 'ml', name: "Malayalam" }, 
    // { code: 'mt', name: "Maltese" }, 
    // { code: 'mi', name: "Maori" }, 
    // { code: 'mr', name: "Marathi" }, 
    // { code: 'mn', name: "Mongolian" }, 
    // { code: 'my', name: "Myanmar (Burmese)" }, 
    // { code: 'ne', name: "Nepali" }, 
    // { code: 'no', name: "Norwegian" }, 
    // { code: 'ny', name: "Nyanja (Chichewa)" }, 
    // { code: 'or', name: "Odia (Oriya)" }, 
    // { code: 'ps', name: "Pashto" }, 
    // { code: 'fa', name: "Persian" }, 
    // { code: 'pl', name: "Polish" }, 
    // { code: 'pt', name: "Portuguese (Portugal, Brazil)" }, 
    // { code: 'pa', name: "Punjabi" }, 
    // { code: 'ro', name: "Romanian" }, 
    // { code: 'ru', name: "Russian" }, 
    // { code: 'sm', name: "Samoan" }, 
    // { code: 'gd', name: "Scots Gaelic" }, 
    // { code: 'sr', name: "Serbian" }, 
    // { code: 'st', name: "Sesotho" }, 
    // { code: 'sn', name: "Shona" }, 
    // { code: 'sd', name: "Sindhi" }, 
    // { code: 'si', name: "Sinhala (Sinhalese)" }, 
    // { code: 'sk', name: "Slovak" }, 
    // { code: 'sl', name: "Slovenian" }, 
    // { code: 'so', name: "Somali" }, 
    // { code: 'es', name: "Spanish" }, 
    // { code: 'su', name: "Sundanese" }, 
    // { code: 'sw', name: "Swahili" }, 
    // { code: 'sv', name: "Swedish" }, 
    // { code: 'tl', name: "Tagalog (Filipino)" }, 
    // { code: 'tg', name: "Tajik" }, 
    // { code: 'ta', name: "Tamil" }, 
    // { code: 'tt', name: "Tatar" }, 
    // { code: 'te', name: "Telugu" }, 
    // { code: 'th', name: "Thai" }, 
    // { code: 'tr', name: "Turkish" }, 
    // { code: 'tk', name: "Turkmen" }, 
    // { code: 'uk', name: "Ukrainian" }, 
    // { code: 'ur', name: "Urdu" }, 
    // { code: 'ug', name: "Uyghur" }, 
    // { code: 'uz', name: "Uzbek" }, 
    // { code: 'vi', name: "Vietnamese" }, 
    // { code: 'cy', name: "Welsh" }, 
    // { code: 'xh', name: "Xhosa" }, 
    // { code: 'yi', name: "Yiddish" }, 
    // { code: 'yo', name: "Yoruba" }, 
    // { code: 'zu', name: "Zulu" }, 
  ];
  defaultSettingsData = {
    main_bg_color: environment.clientDetails.main_bg_color,
    bg_primary_color: environment.clientDetails.bg_primary_color,
    bg_secondary_color: environment.clientDetails.bg_secondary_color,
    bg_tertiary_color: environment.clientDetails.bg_tertiary_color,
    font_primary_color: environment.clientDetails.font_primary_color,
    font_secondary_color: environment.clientDetails.font_secondary_color,
    font_tertiary_color: environment.clientDetails.font_tertiary_color,
    fs_main_title: "20px",
    fs_sub_title: "16px",
    fs_sentence: "14px",
    card_shape: "round",
    font_family: "'Roboto', sans-serif",
    is_preview: false,
    footer_bg_primary_color: environment.clientDetails.footer_bg_primary_color,
    footer_font_primary_color: environment.clientDetails.footer_font_primary_color,
    footer_font_secondary_color: environment.clientDetails.footer_font_secondary_color,
    toastr_bg_color: environment.clientDetails.footer_font_primary_color,
    toastr_font_color: environment.clientDetails.footer_bg_primary_color,
    form_bg_color: environment.clientDetails.form_bg_color,
    form_bg_primary_color: environment.clientDetails.bg_primary_color,
    form_bg_secondary_color: environment.clientDetails.bg_secondary_color,
    form_font_primary_color: environment.clientDetails.font_primary_color,
    form_font_secondary_color: environment.clientDetails.form_font_secondary_color,
    subs_bg_primary_color: environment.clientDetails.bg_primary_color,
    subs_bg_secondary_color: environment.clientDetails.bg_secondary_color,
    subs_bg_tertiary_color: environment.clientDetails.bg_tertiary_color,
    subs_font_main_color: environment.clientDetails.font_primary_color,
    subs_font_primary_color: environment.clientDetails.font_primary_color,
    subs_font_secondary_color: environment.clientDetails.font_secondary_color,
    subs_font_tertiary_color: environment.clientDetails.font_tertiary_color
  };
  groups: any;
  constructor(private appPaymentService: AppPaymentTVService,
    private storageService: StorageService,
    private appService: AppService, private http: HttpClient, private ngxLoader: NgxUiLoaderService, private router: Router,
    private web3service: Web3Service,
    private toastr: ToastrService, private currencyPipe: CurrencyPipe, private activatedRoute: ActivatedRoute) {
    // const savedUser = this.storageService.getItem('user_Info') || null;
    // this.userInfoSubject = new BehaviorSubject<any>(savedUser);
      this.listenToRouteChanges();
  }
  
  listenToRouteChanges(): void {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        let route = this.activatedRoute;
        let groupSlug = null;
        // Traverse through all route levels
        while (route) {
          const param = route.snapshot.paramMap.get('groupName');
          if (param) {
            groupSlug = param;
            break;
          }
          route = route.firstChild;
        }
        if (groupSlug) {
          if (groupSlug !== this.activeGroupSlug) {
            this.setActiveGroup({
              group_slug: groupSlug,
              id: 0
            });
          }
        } else {
          // Reset when navigating away from group routes
          this.activeGroupSlug = '';
          this.activeGroupId = 0;
          this.activeGroup = null;
        }
      });
  }
  
  setLeftTabActiveBasedOnRouterURL(message: string) {
    this.subjectChangeMenuItem.next({ text: message });
  }
  getLeftTabActiveBasedOnRouterURL(): Observable<any> {
    return this.subjectChangeMenuItem.asObservable();
  }
  // organizationId (2nd param) should only be passed by genuine LOGIN call sites, using the
  // org id they already used to build their login request — never by silent session-refresh
  // call sites (e.g. guards refreshing on navigation), since those resolve whatever org page
  // is currently being *viewed*, not the org this browser tab is authenticated as.
  sendUserInfo(data: any, organizationId?: string | number) {
    this.userInfo = data;
    if (data?.organization_id) { localStorage.setItem('bb_org_id', String(data.organization_id)); }
    if (organizationId) {
      this.storageService.setOrgSession(organizationId, data);
      this.storageService.setActiveOrgId(organizationId);
    }
    this.userInfoSubject.next(data);
    this.getPubnubToken();
  }

  // organizationId is omitted at login (sendUserInfo) since a fan hasn't
  // chosen which org's community to view yet - that token still works, it
  // just won't carry that org's moderation-channel grants. Callers that DO
  // know which org is being viewed (e.g. opening a community/channel) should
  // pass it and call this again, otherwise the org-specific grants added by
  // generateToken() never make it into this session's token until the fan
  // logs out and back in.
  getPubnubToken(organizationId?: number | string) {
    const URL = API.GET_PUBNUB_TOKEN;
    if(!this.userInfo.id)
      return;
    const PAYLOAD = {
      "user_id": "fan_" + this.userInfo.id,
      organizationId
    }
    this.appService.postRequest(URL, PAYLOAD).subscribe(result => {
      if (result?.pubnub_token?.['status'] === 200 && result?.pubnub_token?.data)
        localStorage.setItem('pubnub_token', result.pubnub_token?.data);
    }, error => {
        this.ngxLoader.stop();
        console.log("getPubnubToken error :", error)
    });
  }
  // Instantly switches this tab to an org already logged into in this browser, hydrating
  // from storage with no network call. Returns true if a stored session was found.
  switchActiveOrg(orgId: string | number): boolean {
    const session = this.storageService.getOrgSession(orgId);
    if (!session) return false;
    this.userInfo = session;
    this.storageService.setActiveOrgId(orgId);
    this.userInfoSubject.next(session);
    return true;
  }

  // getPubnubToken() {
  //   const URL = API.GET_PUBNUB_TOKEN;
  //   if(!this.userInfo.id)
  //     return;
  //   const PAYLOAD = {
  //     "user_id": "fan_" + this.userInfo.id
  //   }
  //   this.appService.postRequest(URL, PAYLOAD).subscribe(result => {
  //     if (result?.pubnub_token?.['status'] === 200 && result?.pubnub_token?.data) 
  //       localStorage.setItem('pubnub_token', result.pubnub_token?.data);
  //   }, error => {
  //       this.ngxLoader.stop();
  //       console.log("getPubnubToken error :", error)
  //   });
  // }

  sendFeatureInfo(data: any) {
    this.featureInfo = data;
    this.featureInfoSubject.next(data);
  }

  getUserInfo(): Observable<any> {
    return this.userInfoSubject.asObservable();
  }

  sendOrgIdInfo(id: any) {
    let orgChanged = id && id !== this.orgId;
    this.orgId = id;
    if (id) { localStorage.setItem('bb_org_id', String(id)); }
    this.orgIdSubject.next(id);
    if (orgChanged) {
      this.getAvailBalance(() => { }, id);
    }
  }

  getOrgIdInfo(): Observable<any> {
    return this.orgIdSubject.asObservable();
  }

  sendTriggeredEvent(data: any) {
    this.triggeredInfo = data;
    this.triggeredEventInfoSubject.next(data);
  }

  sendOrganizationData(data: any){
    this.currentNetworkData = data;
    this.currentNetworkDataSubject.next(data);
  }

  sendSpaceDetails(data: any){
    console.log("space details sent :", data);
    this.spaceDetails = data;
    this.spaceDetailsSubject.next(data);
  }

  getTriggerAiAgent(): Observable<boolean> {
  return this.triggerAiAgentSubject.asObservable();
  }

  setTriggerAiAgent(value: boolean) {
    this.triggerAiAgentSubject.next(value);
  }

  setActiveGroup(group: any): void {
    this.activeGroupSlug = group.group_slug || '';
    this.groups = this.perfomerInfoData?.data?.Data[0]?.groups || [];
    const matchedGroup = this.groups && this.groups.find((g: any) => g.group_slug === this.activeGroupSlug);
    this.activeGroupId = group.id || matchedGroup?.id || 0;
    this.activeGroup = group?.id ? group : matchedGroup || null;
  }

  getChannelBasePath(channelName: string): string {
    return this.activeGroupSlug
      ? `/${channelName}/${this.activeGroupSlug}`
      : `/${channelName}`;
  }

  // "/<network>" or "/<network>/<group>" taken from a URL. Reads the group from the URL itself
  // rather than activeGroupSlug, which ChannelWebpageGuard doesn't maintain on streaming routes.
  getBasePathFromUrl(url: string): string {
    const [network, segment2] = (url || '').split(/[?#]/)[0].split('/').filter(Boolean);
    if (!network) return '';
    return segment2 && !BASE_PATH_RESERVED_SEGMENTS.has(segment2) ? `/${network}/${segment2}` : `/${network}`;
  }

  extractIdFromUrl(url: string): string | null {
    try {
      let parsedUrl: URL;

      if (url.startsWith('http')) {
        parsedUrl = new URL(url);
      } else {
        parsedUrl = new URL(url, 'http://dummy.base');
      }

      // 1. Check query params (look for "id" OR "stage")
      const queryId = parsedUrl.searchParams.get("id") || parsedUrl.searchParams.get("stage");
      if (queryId) {
        return queryId;
      }

      // 2. Otherwise, parse last path segment
      const pathSegments = parsedUrl.pathname.split("/");
      const lastSegment = pathSegments[pathSegments.length - 1];

      // Extract ANY number inside last segment (not just at the end)
      const match = lastSegment.match(/(\d+)/g);
      if (match && match.length > 0) {
        return match[match.length - 1]; // take the last numeric chunk
      }

      return null;
    } catch (e) {
      console.error("Invalid URL:", e);
      return null;
    }
  }


  // extractIdFromUrl(url: string): string | null {
  //   try {

  //     let parsedUrl: URL;

  //     if (url.startsWith('http')) {
  //       // Case 1: Full URL
  //       parsedUrl = new URL(url);
  //     } else {
  //       // Case 2: Relative path (prepend dummy origin)
  //       parsedUrl = new URL(url, 'http://dummy.base');
  //     }

  //     // 1. Check query param ?id=...
  //     const queryId = parsedUrl.searchParams.get("id");
  //     if (queryId) {
  //       return queryId;
  //     }

  //     // 2. Otherwise, get last path segment (...-22623)
  //     const pathSegments = parsedUrl.pathname.split("/");
  //     const lastSegment = pathSegments[pathSegments.length - 1];

  //     // Extract trailing number from last segment
  //     const match = lastSegment.match(/(\d+)$/);
  //     if (match) {
  //       return match[1]; // the numeric ID
  //     }

  //     return null;
  //   } catch (e) {
  //     console.error("Invalid URL:", e);
  //     return null;
  //   }
  // }



  getTriggeredEvent(): Observable<any> {
    return this.triggeredEventInfoSubject.asObservable();
  }

  getVideoStreamInfo(): Observable<any> {
    return this.videoStreamInfoSubject.asObservable();
  }

  sendVideoStreamInfo(data:any){
    this.videoStreamInfoSubject.next(data);
    localStorage.setItem('videoStreamInfo', JSON.stringify(data));
  }

  private getSavedVideoStreamInfo() {
    const saved = localStorage.getItem('videoStreamInfo');
    return saved ? JSON.parse(saved) : null;
  }

  getFeatureInfo(): Observable<any> {
    return this.featureInfoSubject.asObservable();
  }

  sendSignUpInfo(data: any) {
    this.signUpInfo = data;
    this.signUpInfoSubject.next(data);
  }

  getSingUpInfo(): Observable<any> {
    return this.signUpInfoSubject.asObservable();
  }

  sendSearchInfo(data: any) {
    this.searchInfo = data;
    this.searchInfoSubject.next(data);
  }

  getSearchInfo(): Observable<any> {
    return this.searchInfoSubject.asObservable();
  }

  sendPaymentInfo(data: any) {
    this.paymentInfo = data;
    this.paymentInfoSubject.next(data);
  }

  getPaymentInfo(): Observable<any> {
    return this.paymentInfoSubject.asObservable();
  }

  sendStreamInfo(data: any) {
    this.streamInfo = data;
    this.streamInfoSubject.next(data);
  }

  getStreamInfo(): Observable<any> {
    return this.streamInfoSubject.asObservable();
  }

  sendSubEventsInfo(data: any) {
    this.subEventsInfo = data;
    this.subEventInfoSubject.next(data);
  }
  getSubEventsInfo(): Observable<any> {
    return this.subEventInfoSubject.asObservable();
  }

  sendExpoDetailsToHeader(data: any) {
    this.expoInfo = data;
    this.expoInfoSubject.next(data);
  }
  getExpoInfo(): Observable<any> {
    return this.expoInfoSubject.asObservable();
  }

  sendSlugData(data: any) {
    this.slugInfo = data;
    this.slugInfoSubject.next(data);
  }
  getSlugData(): Observable<any> {
    return this.slugInfoSubject.asObservable();
  }

  sendContactInfo(data: any) {
    this.contactsData = data;
    this.ContactDataSubject.next(data);
  }
  getContactInfo(): Observable<any> {
    return this.ContactDataSubject.asObservable();
  }
  sendTicketDetails(data: any) {
    this.ticketInfo = data;
    this.ticketInfoSubject.next(data);
  }
  getTicketDetails(): Observable<any> {
    return this.ticketInfoSubject.asObservable();
  }

  sendContactDetails(data: any) {
    this.contactInfo = data;
    this.contactInfoSubject.next(data);
  }
  getContactDetails(): Observable<any> {
    return this.contactInfoSubject.asObservable();
  }

  sendUpcomingEvents(data: any) {
    this.upcomingEventInfo = data;
    this.upcomingEventInfoSubject.next(data);
  }
  getUpcomingEvents(): Observable<any> {
    return this.upcomingEventInfoSubject.asObservable();
  }
  sendMylistData(data: any) {
    this.myListInfo = data;
    this.myListInfoSubject.next(data);
  }
  getMylistData(): Observable<any> {
    return this.myListInfoSubject.asObservable();
  }

  // sendUserStatus(data: any) {
  //   this.userStatus = data;
  //   this.userStatusSubject.next(data);
  // }

  // getUserStatus(): Observable<any> {
  //   return this.userStatusSubject.asObservable();
  // }

  saveAthletesData(data: any){
    this.athletsData = data;
    this.athletsDataSubject.next(data);
  }

  sendEventSlugData(data: any) {
    this.eventSlugData = data;
    this.eventSlugDataSubject.next(data);
  }
  getEventSlugData(): Observable<any> {
    return this.eventSlugDataSubject.asObservable();
  }

  sendPlayHLSVideo(data: any) {
    this.HLSPlayVideoSubject.next(data);
  }
  getPlayHLSVideo(): Observable<any> {
    return this.HLSPlayVideoSubject.asObservable();
  }

  sendDeviceType(data: any) {
    this.deviceInfo = data;
    this.deviceInfoSubject.next(data);
  }
  getDeviceType(): Observable<any> {
    return this.deviceInfoSubject.asObservable();
  }
  sendAppType(data: any) {
    this.deviceType = data;
    this.deviceAppSubject.next(data);
  }
  getAppType(): Observable<any> {
    return this.deviceAppSubject.asObservable();
  }
  sendICWebpageThemeSettings(data: any) {
    this.icWebpageSettingsData = withReadableThemeText({ ...this.defaultSettingsData, ...data });
    this.icWebpageSettingsSubject.next(this.icWebpageSettingsData);
    this.toasterStyle(data);
    this.tooltipStyle(data);
    this.agentStyle(data);
  }

  agentStyle(theme: any) {
    document.documentElement.style.setProperty('--fa-bg', theme?.ai_agent_bg_color || environment.aiAgentDefaultColors.ai_agent_bg_color);
    document.documentElement.style.setProperty('--fa-accent', theme?.ai_agent_accent_color || environment.aiAgentDefaultColors.ai_agent_accent_color);
    document.documentElement.style.setProperty('--fa-text', theme?.ai_agent_text_color || environment.aiAgentDefaultColors.ai_agent_text_color);
    document.documentElement.style.setProperty('--fa-form', theme?.ai_agent_form_color || environment.aiAgentDefaultColors.ai_agent_form_color);
    // Link/scrollbar colours derived from the same settings, so each network/group stays readable
    const derived = agentThemeVars(theme);
    Object.keys(derived).forEach(name => document.documentElement.style.setProperty(name, derived[name]));
  }

  toasterStyle(theme: any) {
    const bgColor = theme.toastr_bg_color || this.defaultSettingsData.toastr_bg_color;
    const fontColor = theme.toastr_font_color || this.defaultSettingsData.toastr_font_color;
    document.documentElement.style.setProperty('--toast-bg-color', bgColor);
    document.documentElement.style.setProperty('--toast-font-color', fontColor);

    // dynamically inject toastr fill colors
    const color = encodeURIComponent(fontColor);
    const tickSvg = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3Cpath fill='${color}' d='M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.204-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.595c9.997-9.997 26.207-9.997 36.204 0l36.204 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.205-.0001z'/%3E%3C/svg%3E")`;
    document.documentElement.style.setProperty('--toast-success-icon', tickSvg);

    const infoSvg = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3Cpath fill='${color}' d='M256 8C119.043 8 8 119.083 8 256s111.043 248 248 248 248-111.083 248-248S392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z'/%3E%3C/svg%3E")`;
    document.documentElement.style.setProperty('--toast-info-icon', infoSvg);

    const errorSvg = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3Cpath fill='${color}' d='M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z'/%3E%3C/svg%3E")`;
    document.documentElement.style.setProperty('--toast-error-icon', errorSvg);

    const warningSvg = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 576 512'%3E%3Cpath fill='${color}' d='M569.517 440.013 327.852 47.828C317.314 30.642 298.692 20 278.858 20c-19.835 0-38.456 10.642-48.994 27.828L6.482 440.013C-5.547 459.468 2.152 484 22.964 492.32 29.482 494.926 36.24 496 42.998 496h490.005c24.261 0 39.973-26.447 28.514-49.32zM288 192c13.255 0 24 10.745 24 24v96c0 13.255-10.745 24-24 24s-24-10.745-24-24v-96c0-13.255 10.745-24 24-24zm0 224c-17.673 0-32-14.327-32-32s14.327-32 32-32 32 14.327 32 32-14.327 32-32 32z'/%3E%3C/svg%3E")`;
    document.documentElement.style.setProperty('--toast-warning-icon', warningSvg);
  }

  tooltipStyle(theme: any) {
    document.documentElement.style.setProperty('--tooltip-bg-color', theme.toastr_bg_color);
    document.documentElement.style.setProperty('--tooltip-font-color', theme.toastr_font_color);
  }

  getICWebpageThemeSettings(): Observable<any> {
    return this.icWebpageSettingsSubject.asObservable();
  }

  sendMediaPlayerData(data: any) {
    if (data.type != "function") {
      if (data.key == "musicList") {
        this.mediaPlayerData.musicList = data.value;
      } else if (data.key == "subscribedUserPlans") {
        this.mediaPlayerData.subscribedUserPlans = data.value;
      } else if (data.key == "is_show_musicPlayer") {
        this.mediaPlayerData.is_show_musicPlayer = data.value;
      }
    }
    this.mediaPlayerDataSubject.next(data);
  }
  getMediaPlayerData(): Observable<any> {
    return this.mediaPlayerDataSubject.asObservable();
  }

  sendPerfomerInfo(data: any) {
    this.perfomerInfoData = data;
    this.setActiveGroup({
      group_slug: this.activeGroupSlug,
      id: 0
    });
    this.perfomerInfoDataSubject.next(data);
  }
  getPerfomerInfo(): Observable<any> {
    return this.perfomerInfoDataSubject.asObservable();
  }
  sendSubscriberPayedInfo(data: any) {
    this.subscribePayedInfoData = data;
    if (this.subscribePayInfoData && this.subscribePayInfoData.data) {
      this.subscribePayInfoData.data.Subscription_details = data;
    }
    if (this.perfomerInfoData && this.perfomerInfoData.data) {
      this.perfomerInfoData.data.Subscription_details = data;
    }
    this.subscribePayedDataSubject.next(data);
  }
  getSubscribePayedInfo(): Observable<any> {
    return this.subscribePayedDataSubject.asObservable();
  }
  sendSubscribePayInfo(data: any) {
    this.subscribePayInfoData = data;
    this.subscribePayDataSubject.next(data);
  }
  getSubscribePayInfo(): Observable<any> {
    return this.subscribePayDataSubject.asObservable();
  }

  sendCurrentMusicData(data: any) {
    this.musicPlayerData = data;
    this.musicPlayerDataSubject.next(data);
  }
  getCurrentMusicData(): Observable<any> {
    return this.musicPlayerDataSubject.asObservable();
  }

  sendSearchKey(data: any) {
    this.searchVal = data;
    this.searchValSubject.next(data);
  }
  getSearchKey(): Observable<any> {
    return this.searchValSubject.asObservable();
  }

  getPerformerStatus(): Observable<any> {
    return this.performerStatusSubject.asObservable();
  }
  sendAlbumStatus(data) {
    this.albumStatusOpened = data;
    this.albumStatusSUbject.next(data);
  }
  getAlbumStatus(): Observable<any> {
    return this.albumStatusSUbject.asObservable();
  }

  sendTransactionInfo(data: any) {
    this.transactionInfo = data;
    this.transactionInfoSubject.next(data);
  }
  getTransactionInfo(): Observable<any> {
    return this.transactionInfoSubject.asObservable();
  }

  getCartProductCountApi(): Observable<any> {
    return this.getCartProdCountApiCallSubject.asObservable();
  }

  getCryptoBalance(): Observable<any> {
    return this.cryptoBalanceSubject.asObservable();
  }

  sendGuestInfo(data: any) {
    this.guestInfo = data;
    this.guestInfoSubject.next(data);
  }

  getGuestInfo(): Observable<any> {
    return this.guestInfoSubject.asObservable();
  }

  sendCartProductInfo(data: any) {
    this.getCartProductListSubject.next(data);
  }

  getCartProductInfo(): Observable<any> {
    return this.getCartProductListSubject.asObservable();
  }

  sendStreamWebpageStyles(data: any) {
    this.streamWebpageSettings.next(data);
  }

  getStreamWebpageStyles(): Observable<any> {
    return this.streamWebpageSettings.asObservable();
  }

  sendUserCommunityStatus(data: any) {
    this.userCommunityStatus = data;
    this.userCommunityStatusSubject.next(data);
  }

  getUserCommunityStatus(): Observable<any> {
    return this.userCommunityStatusSubject.asObservable();
  }

  fontFamilyList = [
    { id: "1", lable: "Roboto", link: "https://fonts.googleapis.com/css2?family=Roboto&display=swap", code: "'Roboto', sans-serif" },
    { id: "2", lable: "Poppins", link: "https://fonts.googleapis.com/css2?family=Poppins&display=swap", code: "'Poppins', sans-serif" },
    { id: "3", lable: "Open Sans", link: "https://fonts.googleapis.com/css2?family=Open+Sans&display=swap", code: "'Open Sans', sans-serif" },
    { id: "4", lable: "Raleway", link: "https://fonts.googleapis.com/css2?family=Raleway&display=swap", code: "'Raleway', sans-serif" },
    { id: "5", lable: "Ubuntu", link: "https://fonts.googleapis.com/css2?family=Ubuntu&display=swap", code: "'Ubuntu', sans-serif" },
    { id: "6", lable: "PT Sans", link: "https://fonts.googleapis.com/css2?family=PT+Sans&display=swap", code: "'PT Sans', sans-serif" },
  ];

  getFilterMenu(menuList, url, type?) {
    let menus = JSON.parse(JSON.stringify(menuList));
    let menuLink = url;
    if (url && url.includes('-')) {
      menuLink = url.replace(/-/g, ' ');
    }
    if (type && type == 'subMenu') {
      menus.forEach(val => {
        if (val.sub_menu.length > 0) {
          val.sub_menu.forEach(sublist => {
            sublist.subMenuActive = true;
            if (sublist.link == url) {
              sublist.subMenuActive = true;
            } else {
              sublist.subMenuActive = false;
            }
          });
        }
      });
    } else if (url && type && type == 'allMenu') {
      menus.forEach(val => {
        if (val.link) {
          if (val.link == url) {
            val.activeMenu = true;
          } else {
            val.activeMenu = false;
          }
        } else if (!val.link && val.sub_menu.length > 0) {
          val.activeMenuList = false;
          val.sub_menu.forEach(m => {
            if (m.link == url) {
              val.activeMenuList = true;
              m.subMenuActive = true;
            } else {
              m.subMenuActive = false;
            }
          });
        }
      });
    } else {
      menus.forEach(val => {
        val.activeMenu = true;
        if (val.sub_menu.length == 0) {
          if ((menuLink && menuLink.includes(val.name.toLowerCase())) || (url && url.includes(val.link.toLowerCase()))) {
            val.activeMenu = true;
          } else {
            val.activeMenu = false;
          }
        } else {
          const matchedSubMenu = url && val.sub_menu.find(m => url.includes(m.link));
          if ((menuLink && menuLink.includes(val.name.toLowerCase())) || (url && url.includes(val.name.toLowerCase()))) {
            val.activeMenuList = true;
            val.sub_menu[0].subMenuActive = true;
          } else if (!url && type && val.name == type.name) {
            val.activeMenuList = true;
            val.sub_menu[0].subMenuActive = true;
          } else if (matchedSubMenu) {
            val.activeMenuList = true;
            matchedSubMenu.subMenuActive = true;
          } else {
            val.activeMenuList = false;
          }
        }
      });
    }
    return menus;
  }



  initSlider(sliderClass) {
    $(document).ready(function () {
      // $(sliderClass).on('init', () => {
      //   $(sliderClass + " .slick-slide").css({
      //     visibility: 'visible'
      //   });
      // });
      $(sliderClass)?.slick({
        slidesToShow: 4,
        slidesToScroll: 4,
        autoplay: false,
        autoplaySpeed: 1500,
        arrows: true,
        dots: false,
        pauseOnHover: false,
        infinite: false,
        prevArrow: '<div class="Slider-left-arrow pointer"><i class="fa fa-chevron-left" style="font-size: 24px;" aria-hidden="true"></i><div>',
        nextArrow: '<div class="Slider-right-arrow pointer"><i class="fa fa-chevron-right" style="font-size: 24px;" aria-hidden="true"></i></div>',
        responsive: [{
          breakpoint: 1000,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          }
        }, {
          breakpoint: 520,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          }
        }]
      });
      // $('.channels-images-slider2').show();
    });
  }

  getAddress(address, callback) {
    let url = "https://maps.googleapis.com/maps/api/geocode/json?address=" + encodeURIComponent(address) + "&key=" + environment.mapKey + "&language=en";
    fetch(url)
      .then((res) => {
        return res.json();
      }).then((json) => {
        //console.log(json);
        callback(json);
      }).catch(error => {
        console.log(error);
        callback([]);
      });
  }




  validateZip(zip, country, callback) {
    let find = COUNTRIES_LIST.filter(con => con.name == country);
    find = find[0] ? find[0] : {};
    let codes: any = { state: '', country: country, country_code: find.alpha2code, status: false };

    let url = "https://maps.googleapis.com/maps/api/geocode/json?components=postal_code:" + zip + "|country:" + country + "&key=" + environment.mapKey;
    fetch(url)
      .then((res) => {
        return res.json();
      }).then((json) => {
        //console.log(json);
        if (json.results.length > 0) {
          for (var i = 0; i < json.results[0].address_components.length; i++) {
            if (json.results[0].address_components[i].types.indexOf('country') != -1) {
              // if (n == 3) {
              //     codes.country = getCountryISO3(json.results[0].address_components[i].short_name);
              // } else {
              codes.country = json.results[0].address_components[i].short_name;
              // }
              codes.country_name = json.results[0].address_components[i].long_name;
            }
            if (json.results[0].address_components[i].types.indexOf('administrative_area_level_1') != -1) {
              codes.state = json.results[0].address_components[i].short_name;
            }
          }
          codes.status = true;
        }

        callback(codes);
      }).catch(error => {
        console.log(error);
        callback(codes);
      });
  }

  convertInToUTC(date1) {
    var date = new Date(date1);
    var year: any = date.getUTCFullYear();
    var month: any = date.getUTCMonth() + 1;
    var day: any = date.getUTCDate();
    var hours: any = date.getUTCHours();
    var minutes: any = date.getUTCMinutes();
    var seconds: any = date.getUTCSeconds();
    month = (month < 10) ? '0' + month : month;
    day = (day < 10) ? '0' + day : day;
    hours = (hours < 10) ? '0' + hours : hours;
    minutes = (minutes < 10) ? '0' + minutes : minutes;
    seconds = (seconds < 10) ? '0' + seconds : seconds;
    return new Date(year + '-' + month + '-' + day + ' ' + hours + ':' + minutes);
  }

  getAmount(streamInfo, currentLocation, isSubscriber, ticketsData?) {
    let amounts;
    // ticketsData.amounts = typeof ticketsData.amounts == "string" ? JSON.parse(ticketsData.amounts) : ticketsData.amounts ? ticketsData.amounts : {};

    let currentTime = moment.utc();
    if (streamInfo.current_time) {
      currentTime = moment(streamInfo.current_time);
    }
    let result: any = {};
    amounts = amounts || [];
    let currectDatesAmounts = [];
    let futureDateAmounts = [];
    let ticketsPrice = [];
    let minPrice = 0, maxPrice = 0;
    let isSaleIsOn = false;
    ticketsData.forEach(element => {
      if (element.amounts) {
        // element.amounts = JSON.parse(element.amounts);
        // element.amounts.forEach(date => {
        let cStart = moment.utc(element.start_date);
        let cEnd = moment.utc(element.end_date.replace("00:00", "23:59"));
        let current = this.getPriceWithCurrency(element.amounts, currentLocation, isSubscriber, streamInfo);
        if (current) {
          currectDatesAmounts.push(element);
          element.current = current;
        }
        //console.log('ticket', currectDatesAmounts);
        if (currentTime >= cStart && currentTime <= cEnd) { //here will get only currect date amount
          isSaleIsOn = true;
          element.current = current;
          // currectDatesAmounts.push(element);
          if (minPrice == 0) {
            minPrice = current.price;
          }
          if (maxPrice == 0) {
            maxPrice = current.price;
          }
          if (minPrice >= current.price) {
            minPrice = current.price;
            result.minPrice = current.price;
            result.minCurrency = current.currency;
          }
          if (maxPrice <= current.price) {
            maxPrice = current.price;
            result.maxPrice = current.price;
            result.maxCurrency = current.currency
          }
        } else if (currentTime <= cStart && currentTime <= cEnd) {
          futureDateAmounts.push(element);
        }
        // });
        result.currectDatesAmounts = currectDatesAmounts;
        //console.log('fff', result);
      }
    });


    if (!isSaleIsOn) {
      if (futureDateAmounts.length == 0) {
        result.message = "Sale is completed!";
      } else if (futureDateAmounts.length > 0) {
        // let offset = (new Date().getTimezoneOffset() * -1) + timezone_offset;
        let offset = (new Date().getTimezoneOffset() * -1);
        // if (offset == 0) {
        // booking_start_date is UTC with no timezone marker, same as element.start_date
        // above in this method (parsed via moment.utc there) - formatting it directly showed
        // the wrong calendar date to viewers on the other side of UTC.
        let saleDate = moment.utc(futureDateAmounts[0].booking_start_date).local();
        result.message = "Sale Starts On " + saleDate.format('DD MMM YYYY');
        // } else {
        //   let saleDate = moment(futureDateAmounts[0].booking_start_date).add(offset, 'minutes');
        //   result.message = "Sale Starts At " + saleDate.format('DD MMM YYYY');
        // }
      }
      if (streamInfo.stream_payment_mode == 'free') {
        let eventTime = moment.utc(streamInfo.publish_date_time);
        let currentUTC = moment.utc(streamInfo.current_time);
        if (currentUTC > eventTime) {
          result.message = "Sale is completed!";
        } else {
          result.message = '';
        }
      }
    } else {
      result.currectDatesAmounts = currectDatesAmounts;
    }

    return result;
  }

  // getAmount(streamInfo, currentLocation, isSubscriber, ticketsData) {
  //   let amounts;    
  //   streamInfo.stream_amounts = typeof streamInfo.stream_amounts =="string" ? JSON.parse(streamInfo.stream_amounts) : streamInfo.stream_amounts ? streamInfo.stream_amounts : {};
  //   let timezone_offset = streamInfo.stream_amounts.timezone_offset;
  //   if (streamInfo.stream_vod == "stream" && streamInfo.stream_status != "completed") {
  //     if (isSubscriber && streamInfo.stream_amounts.sub_live_stream  && streamInfo.stream_amounts.sub_live_stream.length > 0) {
  //       amounts = streamInfo.stream_amounts.sub_live_stream;
  //     } else {
  //       amounts = streamInfo.stream_amounts.live_stream;
  //     }
  //   } else {
  //     if (isSubscriber && streamInfo.stream_amounts.sub_vod  && streamInfo.stream_amounts.sub_vod.length > 0) {
  //       amounts = streamInfo.stream_amounts.sub_vod;
  //     } else {
  //       amounts = streamInfo.stream_amounts.vod;
  //     }
  //   }

  //   // let amounts = eventType == 'vod' ? streamInfo.stream_amounts.vod : streamInfo.stream_amounts.live_stream;
  //   let currentTime = moment.utc();
  //   // if (currentLocation.time_zone) {
  //   //   currentTime = moment.utc(currentLocation.time_zone.current_time);
  //   // }
  //   if (streamInfo.current_time) {
  //     currentTime = moment(streamInfo.current_time); 
  //   }

  //   let result: any = {};
  //   let start, end, priceChangeDate;
  //   amounts = amounts || [];

  //   let currectDatesAmounts = [];
  //   let futureDateAmounts = [];
  //   let minPrice = 0,maxPrice = 0;
  //   let isSaleIsOn = false;
  //   amounts.forEach(date => {
  //     let cStart = moment.utc(date.booking_start_date);
  //     let cEnd = moment.utc(date.booking_end_date.replace("00:00", "23:59"));
  //     let current = this.getPriceWithCurrency(date.amounts, currentLocation);
  //     if (currentTime >= cStart && currentTime <= cEnd) { //here will get only currect date amount
  //       isSaleIsOn = true;
  //       date.current = current;
  //       currectDatesAmounts.push(date);
  //       if(minPrice == 0) {
  //         minPrice = current.price;
  //       }
  //       if(maxPrice == 0) {
  //         maxPrice = current.price;
  //       }
  //       if(minPrice >= current.price) {
  //         minPrice = current.price;
  //       result.minPrice = current.price;
  //       result.minCurrency = current.currency;
  //     }
  //       if(maxPrice <= current.price) {
  //         maxPrice = current.price;
  //       result.maxPrice = current.price;
  //       result.maxCurrency = current.currency
  //     }
  //     } else if(currentTime <= cStart && currentTime <= cEnd) {
  //       futureDateAmounts.push(date);
  //     }
  //   });

  //   if(!isSaleIsOn) {
  //     if(futureDateAmounts.length == 0) {
  //       result.message = "Sale is completed!";
  //     } else if(futureDateAmounts.length > 0) {
  //       let offset = (new Date().getTimezoneOffset() * -1) + timezone_offset;
  //       if (offset == 0) {
  //         let saleDate =  moment(futureDateAmounts[0].booking_start_date);
  //         result.message = "Sale Starts On " + saleDate.format('DD MMM YYYY');
  //       } else {
  //         let saleDate =  moment(futureDateAmounts[0].booking_start_date).add(offset, 'minutes');
  //         result.message = "Sale Starts At " + saleDate.format('DD MMM YYYY, hh:mm A');
  //       }
  //     }
  //     // let ctDate = moment().format("YYYY-MM-DD");
  //     // let localTime = moment.utc(streamInfo.publish_date_time).toDate();
  //     // let eventPublishDate = moment(localTime).format('YYYY-MM-DD');
  //     // let currentDate = new Date(ctDate).getTime();
  //     // let eventDate = new Date(eventPublishDate).getTime();
  //     // if(streamInfo.stream_payment_mode == 'free' && currentDate < eventDate){
  //     //   let saleDate =  moment.utc(streamInfo.publish_date_time);
  //     //   result.message = "Sale Starts On " + saleDate.format('DD MMM YYYY');
  //     // }else if(streamInfo.stream_payment_mode == 'free' && currentDate == eventDate){
  //     //   result.message = '';
  //     // }else if(streamInfo.stream_payment_mode == 'free' && currentDate > eventDate){
  //     //   result.message = "Sale is completed!";
  //     // }

  //     if (streamInfo.stream_payment_mode == 'free') {
  //       let eventTime = moment.utc(streamInfo.publish_date_time);
  //       let currentUTC = moment.utc(streamInfo.current_time);
  //       if (currentUTC > eventTime) {
  //         result.message = "Sale is completed!";
  //       } else {
  //         result.message = '';
  //       }
  //     }
  //   } else {
  //     result.currectDatesAmounts = currectDatesAmounts;
  //   }

  //   // amounts.forEach(date => {
  //   //   let cStart = moment.utc(date.booking_start_date);
  //   //   let cEnd = moment.utc(date.booking_end_date.replace("00:00", "23:59"));
  //   //   let current = this.getPriceWithCurrency(date.amounts, currentLocation);
  //   //   if (start && !priceChangeDate && start < cStart) {
  //   //     priceChangeDate = cStart;
  //   //   }
  //   //   if (!start || start > cStart) {        
  //   //     start = cStart;
  //   //     result.minPrice = current.price;
  //   //     result.minCurrency = current.currency;
  //   //   }
  //   //   if (!end || end < cEnd) {
  //   //     end = cEnd;
  //   //     result.maxPrice = current.price;
  //   //     result.maxCurrency = current.currency
  //   //   }
  //   //   if (currentTime >= cStart && currentTime <= cEnd) {
  //   //     result.current = current;
  //   //   }
  //   // });
  //   // if (!result.current) {
  //   //   if (currentTime < start) {
  //   //     result.message = "Sale Starts On " + start.format('DD MMM YYYY');
  //   //   } else if (currentTime > end) {
  //   //     result.message = "Sale is completed!";
  //   //   }
  //   // } else if (priceChangeDate) {
  //   //   result.priceChangeDate = priceChangeDate.format('DD MMM YYYY');
  //   // }

  //   return result;
  // }
  getPriceWithCurrency(amounts, currentLocation, isSubscriber, streamInfo) {
    let dafaultAmount, defaultCurrency, amountSet, currency;
    let amountsInfo = typeof (amounts) == 'string' ? JSON.parse(amounts) : amounts;
    amountsInfo.forEach((amount) => {
      if (currentLocation && currentLocation.currency &&
        amount.currency_type == currentLocation.currency.code) {
        if (isSubscriber)
          amountSet = amount.subscriber;
        else
          amountSet = amount.non_subscriber;
        currency = currentLocation.currency.code;
      } else if (streamInfo.currency_type == amount.currency_type) {
        if (isSubscriber)
          dafaultAmount = amount.subscriber;
        else
          dafaultAmount = amount.non_subscriber;
        defaultCurrency = amount.currency_type;
      }
      // if (amount.country_name == "DEFAULT" || amount.is_default) {
      //   dafaultAmount = amount.stream_payment_amount;
      //   defaultCurrency = amount.currency_type;
      // }
    });
    let result = { price: 0, currency: "" };
    if (amountSet) {
      result.price = parseFloat(amountSet);
      result.currency = currency;
    } else {
      result.price = parseFloat(dafaultAmount);
      result.currency = defaultCurrency;
    }
    return result;
  }

  getStreamDate(streamInfo) {
    let localTime = moment.utc(streamInfo.publish_date_time).toDate();
    let time = moment(localTime).format('hh:mm A');
    let date = moment(localTime).format('ddd, MMM DD');
    let ctDate = moment().format("YYYY-MM-DD");
    let currentDate = new Date(ctDate).getTime();
    if (streamInfo.expected_end_date_time) {
      let endTime = moment.utc(streamInfo.expected_end_date_time).toDate();
      let eventEndDate = moment(endTime).format('YYYY-MM-DD');
      let expected_end_date_time = moment(endTime).format('hh:mm A');
      time += ' - ' + expected_end_date_time;
      let eventDate = new Date(eventEndDate).getTime();
      let currentMonth = moment(localTime).format('MMM')
      if (currentDate == eventDate) {
        date = moment(localTime).format('ddd, MMM DD YYYY');
      } else {
        let checkMonth = moment(endTime).format('MMM');
        if (checkMonth == currentMonth) {
          let end_date_time = moment(endTime).format('DD YYYY');
          let checkDate = date.split(' ');
          let endDate = end_date_time.split(' ');
          if (checkDate[2] == endDate[0])
            date = date + ' ' + new Date().getFullYear();
          else
            date += ' - ' + end_date_time;
        }
        else {
          let end_date_time = moment(endTime).format('MMM DD YYYY');
          date += ' - ' + end_date_time;
        }
      }
    }
    if (streamInfo.stream_vod == 'vod')
      date = moment(localTime).format('ddd, MMM DD YYYY');
    return { date: date, time: time };
  }

  checkIsSubscribePlan(subscription_details, plan_id) {
    let flag = false;
    if (subscription_details && subscription_details.length > 0) {
      subscription_details.forEach(e => {
        if (plan_id == e.plan_id && e.subscription_status != 0 && e.payment == 'success') {
          flag = true;
        }
      });
    } else {
      flag = false;
    }
    return flag;
  }

  checkIsSubscribeFailed(subscription_details, plan_id) {
    let flag = false;
    if (subscription_details && subscription_details.length > 0) {
      subscription_details.forEach(e => {
        if (plan_id == e.plan_id && e.payment == 'failed') {
          flag = true;
        }
      });
    } else {
      flag = false;
    }
    return flag;
  }

  checkIsSubscribePlanReActive(subscription_details, plan_id) {
    let flag = false;
    if (subscription_details && subscription_details.length > 0) {
      subscription_details.forEach(e => {
        if (plan_id == e.plan_id && e.subscription_status == 0 && (new Date().getTime() < new Date(e.subscription_end_date).getTime() || e.tier_amount_mode == 'noExpiry')) {
          flag = true;
        }
      });
    } else {
      flag = false;
    }
    return flag;
  }

  getSubscribedAmount(subscription_details, data) {
    if (subscription_details && subscription_details.length > 0) {
      subscription_details.forEach(e => {
        if (data.id == e.plan_id) {
          data.subscription_amount = e.subscription_amount;
          data.currency = e.currency ? e.currency.toUpperCase() : "";
        }
      });
    }
  }

  // Shared in-flight lookup: on a first visit app.component, the route guard, event-nav and the
  // page component all ask for the location at once - reuse one request instead of firing one each.
  private pendingLocationLookup: Promise<any> | null = null;

  getCurrentLocation(callback: (status: any, val: any) => void) {
    this.locationInfo = this.storageService.getItem("current_location");
    if (!this.locationInfo || Object.keys(this.locationInfo).length == 0) {
      if (!this.pendingLocationLookup) {
        const lookup = this.fetchCurrentLocation();
        this.pendingLocationLookup = lookup;
        lookup.then(() => this.pendingLocationLookup = null, () => this.pendingLocationLookup = null);
      }
      this.pendingLocationLookup
        .then((json) => callback('success', json))
        .catch(() => callback('fail', {}));
    } else {
      callback('success', this.locationInfo);
    }
  }

  private fetchCurrentLocation(): Promise<any> {
    return fetch("https://api.ipgeolocation.io/ipgeo?apiKey=" + environment.ipGeoKey)
        .then((res) => {
          return res.json();
        }).then((json) => {
          if (localStorage.currency) {
            json.currency.code = localStorage.currency
          }
          this.locationInfo = json;
          if (this.locationInfo) {
            let currency = this.storageService.getItem('currency');
            if (!currency) {
              let code = this.locationInfo.currency.code.includes('\"') ? JSON.parse(this.locationInfo.currency.code) : this.locationInfo.currency.code;
              this.storageService.setItem('currency', code);
              currency = this.storageService.getItem('currency');
            }
          }
          //console.log("http://ip-api.com/json/", json);
          return json;
        });
  }

  getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor || window['opera'];
    if (/windows phone/i.test(userAgent)) {
      return 'web';
    }
    if (/android/i.test(userAgent)) {
      return 'android';
    }
    if (/iPhone|iPod/.test(userAgent) && !window['MSStream']) {
      return 'ios';
    }
    return 'web';
  }

  markFormGroupTouched(formGroup: FormGroup) {
    (<any>Object).values(formGroup.controls).forEach(control => {
      control.markAsTouched();

      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }

  scrollTo(el: Element): void {
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  scrollToError(): void {
    const firstElementWithError = document.querySelector('.ng-invalid[formControlName]');
    return this.scrollTo(firstElementWithError);
  }

  public getCurrenciesJSON(): Observable<any> {
    return this.http.get("../../assets/currencies.json");
  }

  sendCurrencyInfo(data: any) {
    this.currencyInfo = data;
    this.currencyInfoSubject.next(data);
  }
  getCurrencyInfo(): Observable<any> {
    return this.currencyInfoSubject.asObservable();
  }


  // checkscreenStaus()
  sendScreenStatus(data: any) {
    this.screenStatusSubject.next(data);
  }
  getScreenStatus(): Observable<any> {
    return this.screenStatusSubject.asObservable();
  }

  sendPaymentStatus(data: any) {
    this.paymentStatusSubject.next(data);
  }
  getPaymentStatus(): Observable<any> {
    return this.paymentStatusSubject.asObservable();
  }

  sendCurrentStreamStatus(data: any) {
    this.streamStatusInfo = data;
    this.streamStatusInfoSubject.next(data);
  }
  getCurrentStreamStatus(): Observable<any> {
    return this.streamStatusInfoSubject.asObservable();
  }

  sendTrackingCode(data: any) {
    this.trackingCodeInfo = data;
    this.trackingCodeInfoSubject.next(data);
  }
  getTrackingCode(): Observable<any> {
    return this.trackingCodeInfoSubject.asObservable();
  }

  sendLoginStatus(data: any) {
    this.loginStatusInfo = data;
    this.loginStatusInfoSubject.next(data);
  }
  getLoginStatus(): Observable<any> {
    return this.loginStatusInfoSubject.asObservable();
  }

  getActiveProductsList(): Observable<any> {
    return this.showActiveProducts.asObservable();
  }

  getCartProductsCount(): Observable<any> {
    return this.cartProductsSubject.asObservable();
  }
  getCartStatus(): Observable<any> {
    return this.cartRefreshSubject.asObservable();
  }

  getCurencyRates(): Observable<any> {
    return this.currencyRatesSubject.asObservable();
  }

  getCheckoutTimer(): Observable<any> {
    return this.checkoutTimer.asObservable();
  }

  getSelectedCardInfo(): Observable<any> {
    return this.selectedCardSubject.asObservable();
  }

  getAddressList(): Observable<any> {
    return this.addressListSubject.asObservable();
  }

  getSavedCards(): Observable<any> {
    return this.savedCardsSubject.asObservable();
  }

  getBillingInfo(): Observable<any> {
    return this.billingInfoSubject.asObservable();
  }

  getTotalAmount(): Observable<any> {
    return this.totalAmountSubject.asObservable();
  }

  getFormsValidationVal(): Observable<any> {
    return this.formsValidationSubject.asObservable();
  }

  getUserDetail(): Observable<any> {
    return this.userDetailSubject.asObservable();
  }

  getFormStatus(): Observable<any> {
    return this.formStatusSubject.asObservable();
  }

  updateAvailBal(): Observable<any> {
    return this.updateAvailBalSubject.asObservable();
  }

  updatePaymentBtn(): Observable<any> {
    return this.updatePaymentBtnSubject.asObservable();
  }

  getScrollStatus(): Observable<any> {
    return this.scrollStatusSubject.asObservable();
  }

  googleTranslateElementInit() {
    let interval = setInterval(() => {
      if (typeof google != 'undefined') {
        new google.translate.TranslateElement(
          {
            pageLanguage: 'en',
            // includedLanguages: 'es,en,zh-CN,ja',
            autoDisplay: false
          },
          'google_translate_element'
        );
        clearInterval(interval);
      }
    }, 1000);
  }

  countAdsImpressions(url) {
    fetch(url /*, options */)
      .then((response) => response.text())
      .then((html) => {
        // document.getElementById("content").innerHTML = html;
      })
      .catch((error) => {
        console.warn(error);
      });
  }

  setLangCookie(lang) {
    let expireDays = 1;
    let path = '/';
    let name = 'googtrans';
    let value = '/en/' + lang;
    let d: Date = new Date();
    d.setTime(d.getTime() + expireDays * 24 * 60 * 60 * 1000);
    let expires: string = `expires=${d.toUTCString()}`;
    let cpath: string = path ? `; path=${path}` : '';
    document.cookie = `${name}=${value}; ${expires}${cpath}`;
  }

  changeLanguage(lang) {
    if (lang == 'en-US' || lang == 'en-GB') {
      lang = 'en';
    }
    this.storageService.setItem('lang', lang);
    let element = document.getElementsByClassName('goog-te-combo')[0];
    element['value'] = lang;
    //console.log(lang);
    var event;
    if (document.createEvent) {
      event = document.createEvent('HTMLEvents');
      event.initEvent('change', true, true);
      element.dispatchEvent(event);
    } else {
      event = document.createEventObject();
      event.eventType = 'change';
      element.fireEvent('on' + event.eventType, event);
    }
  }

  getLanguage() {
    let lang = 'en';
    let cname = 'googtrans';
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        lang = c.substring(name.length, c.length);
        //console.log('1', lang);
        lang = lang.split('/en/')[1];
      }
    }
    //console.log('2', lang);
    lang = this.storageService.getItem('lang');
    if (!lang) {
      lang = navigator.language ? navigator.language : navigator.languages[0];
      if (lang == 'en-US' || lang == 'en-GB') {
        lang = 'en';
      }
      let status = false;
      for (let i = 0; i < this.languages.length; i++) {
        if (lang == this.languages[i]['code']) {
          status = true;
          break;
        }
      }
      if (!status) {
        lang = '';
      }
    }
    let status = false;
    for (let i = 0; i < this.languages.length; i++) {
      if (lang == this.languages[i]['code']) {
        status = true;
        break;
      }
    }
    if (!status) {
      lang = '';
    }
    return lang;
  }
  async getAdsDataSDK(data, callback) {
    let Ads_data = [];
    await this.getIP((err, result) => {
      //console.log("IP from if block:: ", this.ip);
      if (data.placements.length > 0) {
        let val: any = {
          placements: data.placements
        };
        if (this.ip) {
          val.ip = this.ip;
        }
        let client = new Client({ networkId: data.placements[0].networkId, siteId: data.placements[0].siteId });

        client.decisions.get(val).then(response => {
          // console.dir(response, { depth: null });
          data.allDiv.forEach(element => {
            //console.log("json.decisions ::", json.decisions[element]);
            if (response.decisions && response.decisions[element]) {
              Ads_data.push(response.decisions[element][0]);
            }
          });
          callback(null, { status: 0, message: "success", Ads_data: Ads_data });
        });
      } else {
        callback(null, { status: 0, message: "success", Ads_data: Ads_data });
      }
    });
  }
  async getAdsData(data, callback) {
    let Ads_data = [];
    await this.getIP((err, result) => {
      //console.log("IP from if block:: ", this.ip);
      if (data.placements.length > 0) {
        let val: any = {
          placements: data.placements
        };
        if (this.ip) {
          val.ip = this.ip;
        }
        //console.log("val", val);
        fetch('https://e-' + Number(environment.kevel.NETWORK_ID) + '.adzerk.net/api/v2', {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(val)
        }).then((data) => {
          return data.json();
        }).then((json) => {
          data.allDiv.forEach(element => {
            //console.log("json.decisions ::", json.decisions[element]);
            if (json.decisions && json.decisions[element]) {
              Ads_data.push(json.decisions[element]);
            }
          });
          callback(null, { status: 0, message: "success", Ads_data: Ads_data });
        }).catch(error => {
          callback(error, null);
        });
      } else {
        callback(null, { status: 0, message: "success", Ads_data: Ads_data });
      }
    });
  }
  async getAdsData_API(data, callback) {
    let Ads_data = [];
    await this.getIP((err, result) => {
      //console.log("IP from if block:: ", this.ip);
      if (data.placements.length > 0) {
        let val: any = {
          placements: data.placements,
          siteId: data.placements[0].siteId,
          networkId: Number(environment.kevel.NETWORK_ID)
        };
        if (this.ip) {
          val.ip = this.ip;
        }
        //console.log("val", val);
        this.appService.postRequest(CONST_AWS_API.KEVEL_ADS, val).subscribe(resp => {
          data.allDiv.forEach(element => {
            // console.log(json.decisions[element]);

            if (resp.data.decisions && resp.data.decisions[element]) {
              resp.data.decisions[element].forEach(ele => {
                if (ele != null)
                  Ads_data.push(ele);
              });
            }
          });
          callback(null, { status: 0, message: "success", Ads_data: Ads_data });
        }, error => {
          callback(error, null);
        });
        // fetch('https://e-' + Number(environment.kevel.NETWORK_ID) + '.adzerk.net/api/v2', {
        //   method: 'POST',
        //   headers: {
        //     'Accept': 'application/json',
        //     'Content-Type': 'application/json'
        //   },
        //   body: JSON.stringify(val)
        // }).then((data) => {
        //   return data.json();
        // }).then((json) => {
        //   data.allDiv.forEach(element => {
        //     // console.log(json.decisions[element]);
        //     if (json.decisions && json.decisions[element]) {
        //       Ads_data.push(json.decisions[element]);
        //     }
        //   });
        //   callback(null, { status: 0, message: "success", Ads_data: Ads_data });
        // }).catch(error => {
        //   callback(error, null);
        // });
      } else {
        callback(null, { status: 0, message: "success", Ads_data: Ads_data });
      }
    });
  }

  async getIP(callback) {
    fetch('https://api.ipify.org/?format=json').then((data) => {
      return data.json();
    }).then((json) => {
      if (json && json.ip) {
        this.ip = json.ip;
        callback(null, this.ip);
      }
      //console.log("getIP json", json);
    }).catch(error => {
      callback(error, null);
      console.log("getIP error", error);
    });;
  }

  isSubChannelPresent;
  settingsData: any = {};
  lastFetchedGroupId: number = -1;
  isFetchingWebPageSettings: boolean = false;
  queuedWebPageSettingsArgs: any[] = null;
  getWebPageSettings(id, channelName?, group?) {
    if (this.isFetchingWebPageSettings) {
      this.queuedWebPageSettingsArgs = [id, channelName, group];
      return;
    }
    if (this.icWebpageSettingsData && this.icWebpageSettingsData.channelInfo && (id != this.icWebpageSettingsData.channelInfo.channel_id || this.activeGroupId != this.lastFetchedGroupId)) {
      this.isFetchingWebPageSettings = true;
      const requestedGroupId = this.activeGroupId;
      let type = channelName ? 'channel_name' : 'channel_id';
      let myInit = {
        headers: {
          'x-api-key': environment.AWS_Cognito.X_Api_Key
        },
        response: true,
        body: id != 0 ? {
          [type]: id,
          "organization_id": this.icWebpageSettingsData.channelInfo.org_id,
          "network_group_id": this.activeGroupId
        } : {
          "organization_id": this.icWebpageSettingsData.channelInfo.org_id,
          "network_group_id": this.activeGroupId
        }
      }
      dedupedPost(AWS_API.post.bind(AWS_API), environment.AWS_Cognito.apiName, CONST_AWS_API.GET_EVENT_WEBPAGE, myInit).then(response => {

        this.ngxLoader.stop();
        let settingsData: any = {};
        // let webSettings:any = (this.isSubChannelPresent && response.data.Data[0].template == 1 ) ? response.data.Data[0].settings : response.data.Data[0]
        let webSettings = response.data.Data ? response.data.Data[0] : {};
        if (this.router.url.includes('preview')) {
          if (webSettings && webSettings.webpage_settings_preview && Object.keys(webSettings.webpage_settings_preview).length > 0) {
            settingsData = JSON.parse(webSettings.webpage_settings_preview);
          } else {
            settingsData = this.defaultSettingsData;
          }
          settingsData.is_preview = true;
        } else {
          if (webSettings && webSettings.webpage_settings_publish && Object.keys(webSettings.webpage_settings_publish).length > 0) {
            settingsData = JSON.parse(webSettings.webpage_settings_publish);
          } else {
            settingsData = this.defaultSettingsData;
          }
          settingsData.is_preview = false;
        }

        if (settingsData.fs_main_title) {
          settingsData.fs_main_title = settingsData.fs_main_title + "px";
        }
        if (settingsData.fs_sentence) {
          settingsData.fs_sentence = settingsData.fs_sentence + "px";
        }
        if (settingsData.fs_sub_title) {
          settingsData.fs_sub_title = settingsData.fs_sub_title + "px";
        }

        if (settingsData.subs_fs_main_title) {
          settingsData.subs_fs_main_title = settingsData.subs_fs_main_title + "px";
        }
        if (settingsData.subs_fs_sentence) {
          settingsData.subs_fs_sentence = settingsData.subs_fs_sentence + "px";
        }
        if (settingsData.subs_fs_sub_title) {
          settingsData.subs_fs_sub_title = settingsData.subs_fs_sub_title + "px";
        }
        if (settingsData.form_fs_main_title) {
          settingsData.form_fs_main_title = settingsData.form_fs_main_title + "px";
        }
        if (settingsData.font_family) {
          let data: any = this.fontFamilyList.filter(a => a.id == settingsData.font_family);
          if (data && data.length > 0) {
            var fileref = document.createElement("link");
            fileref.setAttribute("rel", "stylesheet");
            fileref.setAttribute("type", "text/css");
            fileref.setAttribute("href", data[0].link);
            document.getElementsByTagName("head")[0].appendChild(fileref);
            settingsData.font_family = data[0].code;
          }
        }
        if (Object.keys(settingsData).length == 0) {
          settingsData = this.defaultSettingsData;
        }
        let channel = {
          org_id: this.icWebpageSettingsData.channelInfo.org_id,
          channel_id: webSettings && webSettings.channel_id ? webSettings.channel_id : 0,
          channel_display_name: webSettings && webSettings.channel_display_name ? webSettings.channel_display_name : "",
          channel_name: webSettings && webSettings.channel_name ? webSettings.channel_name : "",
          subscription: webSettings && webSettings.subscription === 1 ? 1 : 0,
          template: webSettings && webSettings.template === 1 ? 1 : 0,
          channel_logo: webSettings && webSettings.logo ? webSettings.logo : ""
        }
        settingsData.channelInfo = channel;
        const hasEventKey = Object.keys(settingsData || {}).some(key => key.startsWith('event_'));
        if (!hasEventKey) {
          settingsData = { ...settingsData, ...environment.eventDefaultColors };
        }
        const hasMerchKey = Object.keys(settingsData || {}).some(key => key.startsWith('merchandise_'));
        if (!hasMerchKey) {
          settingsData = { ...settingsData, ...environment.merchandiseDefaultColors };
        }
        const hasCommKey = Object.keys(settingsData || {}).some(key => key.startsWith('space_'));
        if (!hasCommKey) {
          settingsData = { ...settingsData, ...environment.communityDefaultColors };
        }
        const hasAiAgentKey = Object.keys(settingsData || {}).some(key => key.startsWith('ai_agent_'));
        if (!hasAiAgentKey) {
          settingsData = { ...settingsData, ...environment.aiAgentDefaultColors };
        }
        if (!settingsData.toastr_bg_color) {
          settingsData.toastr_bg_color = this.defaultSettingsData.toastr_bg_color;
          settingsData.toastr_font_color = this.defaultSettingsData.toastr_font_color;
        }
        settingsData.banner_image = webSettings && webSettings.banner_image ? webSettings.banner_image : DEFAULT_IMAGE.IMAGE_2;
        this.isFetchingWebPageSettings = false;

        // The active group may have changed (e.g. user navigated back to network, or into a
        // different group) while this GET_EVENT_WEBPAGE request was in flight. Applying a
        // stale response now would overwrite the new scope's colors with this one's - discard it,
        // and replay the call that was dropped while this one was in flight so the new scope loads.
        const queuedArgs = this.queuedWebPageSettingsArgs;
        this.queuedWebPageSettingsArgs = null;
        if (this.activeGroupId !== requestedGroupId) {
          if (queuedArgs) {
            this.getWebPageSettings(queuedArgs[0], queuedArgs[1], queuedArgs[2]);
          }
          return;
        }

        this.lastFetchedGroupId = this.activeGroupId;
        this.sendICWebpageThemeSettings(settingsData);
        //console.log(settingsData)
        //console.log("settingsData", settingsData);
        this.storageService.setItem("channelName", this.router.url.split('/')[1])
        //console.log(localStorage.getItem("ThemelocalData"),)

      }).catch(error => {
        this.ngxLoader.stop();
        this.isFetchingWebPageSettings = false;
        return false;
      });
    }
  }

  trackFBEvents(eventName, amount?) {
    if (eventName != 'Subscribe') {
      try { fbq('track', eventName); } catch (e) { };
    } else {
      try { fbq('track', 'Subscribe', amount); } catch (e) { }
    }
  }

  trackGoogleAnalytics(eventName, amount?) {
    if (eventName != 'purchase') {
      try {
        gtag("event", eventName);
      } catch (e) { }
    } else {
      try { gtag("event", eventName, amount); } catch (e) { }
    }
  }

  getProductsPrice(productsList, id, data, callback) {
    productsList.forEach(element => {

      // element.price_details = [{ currency_type: 'USD', price: '5.00' }, { currency_type: 'GBP', price: '5.99' }];
      if (element.id == id) {
        // if(element.id == 455){
        //   element.price_details = [{ currency_type: 'AED', price: '115.00' }, { currency_type: 'EUR', price: '54.99' }];
        // }else{
        //   element.price_details = [{ currency_type: 'USD', price: '5.00' }, { currency_type: 'GBP', price: '5.99' }];
        // }
        element.convertTo = false;
        let currencyVal = false;
        element.pricing = typeof element.pricing == 'object' ? element.pricing : JSON.parse(element.pricing);
        if (element.pricing && element.pricing.length > 0) {
          element.pricing.forEach(e => {
            if (data.currency && e.currency_type == data.currency && !currencyVal) {
              element.price = Number(e.price);
              element.currency_type = e.currency_type;
              currencyVal = true;
            } else if (data.currentLocation && data.currentLocation.currency && e.currency_type == data.currentLocation.currency.code && !currencyVal) {
              element.price = Number(e.price);
              element.currency_type = e.currency_type;
              currencyVal = true;
            }
            // else if (data.streamData && data.streamData.currency_type && e.currency_type == data.streamData.currency_type && !currencyVal) {
            //   element.price = Number(e.price);
            //   element.currency_type = e.currency_type;
            //   currencyVal = true;
            // } 
          })
          if (!element.price || !currencyVal) {
            element.price = Number(element.pricing[0].price);
            element.currency_type = data.currency;
            element.convertTo = true;
          }
        }
        callback(element);
      }
    })
  }

  getAvailBalance(callback, organizationId = this.orgId) {
    let cached = this.walletByOrg[organizationId];
    if ((!cached || Object.keys(cached).length == 0) && this.userInfo.id) {
      this.appPaymentService.getRequestWithParams(API.GET_WALLET, { organization_id: organizationId ?? '' }).subscribe(response => {
        if (response.status == 0) {
          this.walletByOrg[organizationId] = response["wallet"];
          this.availBal = this.walletByOrg[organizationId];
          callback(this.walletByOrg[organizationId]);
          this.walletInfoSubject.next({ organizationId: organizationId, wallet: this.walletByOrg[organizationId] });
        }
      }, error => {
        // console.log("error get avail", error);
        // this.toastr.error("//////" + error.error);
      });
    } else {
      callback(cached);
    }
  }
  convertToCryptoAmount(amount, rates) {
    let conv_amt = rates * 1.025;
    let value_in_usd = (amount / conv_amt);
    let tokens = value_in_usd * environment.ONE_USD;
    return tokens;
  }

  getCurrencyRates(currency, callback) {
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        "Authorization": `Bearer ${this.userInfo.access_token}`
      },
      response: true,
      body: {}
    }
    let url = CONST_AWS_API.GET_EXCHANGE_RATES + '/' + currency;
    AWS_API.get(environment.AWS_Cognito.apiName, url, data).then(response => {
      if (response.data.statusCode === '200') {
        if (response['data']['Data']['rates']) {
          let usdrates = response['data']['Data']['rates'];
          callback(usdrates)
        }
      }

    })
      .catch((e) => {
        console.log(e);
      })
  }

  cryptoCurrencyConversion(tokens, rates) {
    let tokens_in_usd = tokens / environment.ONE_USD;
    return (tokens_in_usd * rates * 1.025);
  }
  cryptoFiatConversion(tokens, rates) {
    let tokens_in_usd = tokens / environment.ONE_USD;
    return (tokens_in_usd * rates);
  }
  convertTokenIdFormat(tokenId) {
    if (typeof (tokenId) == 'string') {
      console.log(tokenId.split("_") && tokenId.split("_").length > 1 ? tokenId.split("_")[1] : tokenId)
      return Number(tokenId.split("_") && tokenId.split("_").length > 1 ? tokenId.split("_")[1] : tokenId)
    }
    console.log(tokenId)
    return Number(tokenId)
  }
  getCurPrice(data, callback) {
    if (data) {
      var val = this.currencyPipe.transform(Number(data.price).toFixed(2), data.currency);
      callback(val);
    } else {
      callback(this.availBal);
    }
  }


  getAccountBalance(walletID) {
    console.log("get account balance called", walletID);
    if (walletID != '') {
      console.log("walletID", walletID);
      this.web3service.setNetwork(environment.clientDetails.network_name);
      let erc20contract = this.web3service.getContract('ERC20');
      this.web3service.checkAndInstantiateWeb3().then(isweb3 => {
        if (isweb3 === 'connected' && walletID) {
          console.log("inside if", erc20contract.methods.balanceOf(walletID).call());
          erc20contract.methods.balanceOf(walletID).call().then(resp => {
            console.log("resp??????????/", resp);
            console.log("resp", Number(resp) / (10 ** 18));
            let available_balance = Number(resp) / (10 ** 18);
            console.log("available_balance", available_balance);
            let crypto_balance = Math.trunc(available_balance * Math.pow(10, 3)) / Math.pow(10, 3);
            console.log("crypto_balance", crypto_balance);
            let result = {
              "available_balance": available_balance > 0 ? available_balance : 0,
              "crypto_balance": crypto_balance > 0 ? crypto_balance : 0
            }
            console.log("alance", result);
            this.cryptoBalanceSubject.next(result)
          })
        }
      })
        .catch((e) => {
          if (e.message.includes('The requested account and/or method has not been authorized by the user.')) {
            this.toastr.error("Your wallet has been blocked");
          }
        })
    }
  }


  getParam(param) {
    try {
      let url = decodeURIComponent(location.href).split("?");
      let queryParams = url[1] ? url[1].split("&") : [];
      let params = {};
      if (queryParams && queryParams.length > 0) {
        queryParams.forEach(p => {
          let p1 = p.split("=");
          params[p1[0]] = p1[1];
        });
      }
      return params[param];
    } catch (e) {
      console.log(e);
      return this.activatedRoute.snapshot.queryParamMap.get(param);
    }
  }

  getThemeColors() {

    const themeColor = environment.themeColors;
    return {
      primaryColor: themeColor['primary_theme_color1'],
      primaryFontColor: themeColor['secondary_theme_color2'],
      secondaryColor: themeColor['tertiary_theme_color3'],
      secondaryFontColor: themeColor['quaternary_theme_color4'],
      tertiaryColor: themeColor['pentagon_theme_color5'],
      tertiaryFontColor: themeColor['hexagon_theme_color6'],
      quaternaryColor: themeColor['heptagon_theme_color7'],
      primaryFontFamily: themeColor['primary_font_family'],
      secondaryFontFamily: themeColor['secondary_font_family'],
      tertiaryFontFamily: themeColor['tertiary_font_family'],
      //tertiaryLightColor: themeColor['tertiaryLightColor'],

      // For sample page
      samplePrimaryTheme: themeColor['primary_theme_color1'],
      sampleSecondaryTheme: themeColor['secondary_theme_color2'],
      sampleTertiaryTheme: themeColor['tertiary_theme_color3'],
      sampleQuaternaryTheme: themeColor['quaternary_theme_color4'],
      samplePentanaryTheme: themeColor['pentagon_theme_color5'],
      sampleHexonaryTheme: themeColor['hexagon_theme_color6'],
      sampleHeptanaryTheme: themeColor['heptagon_theme_color7'],
      sampleSeptanaryTheme: themeColor['septanary_bg_color'],
      sampleOctanaryTheme: themeColor['octanary_bg_color'],
      sampleNonaryTheme: themeColor['nenone_bg_color']
    }

  }
  convertUTCToLocalTime(date, zone) {
    return moment.utc(date, "YYYY/MM/DD HH:mm:ss A").tz(zone);
  }
  private fanLoginSubject = new BehaviorSubject<boolean>(
    localStorage.getItem('isFanLoginUser') === 'true'
  );
  isFanLoginUser$ = this.fanLoginSubject.asObservable();

  updateFanLoginStatus(status: boolean) {
    localStorage.setItem('isFanLoginUser', status.toString());
    this.fanLoginSubject.next(status);
  }
  sendPubnubkeysetInfo(data: any) {
    this.pubnubKeysetSubject.next(data);
  }

  getPubnubkeysetInfo(): Observable<any> {
    return this.pubnubKeysetSubject.asObservable();
  }

  saveDateOfBirth(ageLimit: number, organizationId: any): void {
    // if (this.userInfo.date_of_birth) return;
    let date = new Date();
    date.setFullYear(date.getFullYear() - ageLimit);
    let birthdate = moment((date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear()).format("YYYY-MM-DD");
    const profileData = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        "Authorization": `Bearer ${this.userInfo.access_token}`
      },
      response: true,
      body: {
        "user_id": this.userInfo.id,
        "user_first_name": this.userInfo.user_first_name,
        "user_last_name": this.userInfo.user_last_name,
        "user_email": this.userInfo.email,
        "user_phone_number": this.userInfo.user_phone_number || '',
        "country_code": this.userInfo.country_code || '',
        "dial_code": this.userInfo.dial_code || '',
        "date_of_birth": birthdate,
        "organization_id": organizationId
      }
    };
    AWS_API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.UPDATE_PROFILE, profileData)
      .then(() => { this.userInfo.date_of_birth = birthdate; })
      .catch(() => {});
  }
}